import axios from 'axios';
import type { IGetLiveConciergePriceRequest } from '@/app-package';
import { Country } from '@bb/automaton';

/**
 * TODO: This entire thing is stubbed out waiting until KB-1942 is finished and merged.
 */
const getLiveConciergePrice = async ({
  unitCount,
  country,
}: {
  unitCount: number;
  country: Country | `${Country}`;
}) => {
  // Set the currency depending on what country this request is from.
  let currency: string;
  if (country === 'CAN') {
    currency = 'CAD';
  } else {
    currency = 'USD';
  }

  const config: IGetLiveConciergePriceRequest = {
    url: `/whatever_url/?billingProductName=SHO-LCS-BROK&value=${unitCount}&currency=${currency}`,
    method: 'get',
  };
  const { data } = await axios.request<number>(config);
  return data;
};

export default getLiveConciergePrice;
